import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Space, Typography, Divider, Row, Col, Select, message, Tabs, Modal, Table, Tag, Popconfirm, Checkbox, } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, HomeOutlined, CreditCardOutlined, PlusOutlined, EditOutlined, DeleteOutlined, SafetyOutlined, } from '@ant-design/icons';
import { useAuth } from '../hooks/useAuth';
import { useApi } from 'sysone-api-mapper';
import { openNotificationWithIcon, TYPE, PaymentMethods } from "@sysone/insureblocks";
import { IoBusinessOutline } from "react-icons/io5";
const { Title, Text } = Typography;
const { Option } = Select;
const ProfilePage = () => {
    const { user } = useAuth();
    const [personalForm] = Form.useForm();
    const personalFormValues = Form.useWatch([], personalForm);
    const [paymentForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [paymentModalVisible, setPaymentModalVisible] = useState(false);
    const [editingPayment, setEditingPayment] = useState(null);
    const [banks, setBanks] = useState([]);
    const api = useApi();
    const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
    const [cardTypes, setCardTypes] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [postalCodes, setPostalCodes] = useState([]);
    const [partyPersonType, setPartyPersonType] = useState("INDIVIDUAL");
    const [phoneTypes, setPhoneTypes] = useState([]);
    const [addressesTypes, setAddressesTypes] = useState([]);
    useEffect(() => {
        const fetch_address_types = async () => {
            const data = await api.party.getAdressTypes();
            setAddressesTypes(data.values || []);
        };
        fetch_address_types();
    }, []);
    useEffect(() => {
        const fetch_phone_types = async () => {
            const data = await api.party.getPhoneTypes();
            setPhoneTypes(data.values || []);
        };
        fetch_phone_types();
    }, []);
    // Mock data - in production this would come from API
    const [personalData, setPersonalData] = useState(undefined);
    const [partyDetails, setPartyDetails] = useState();
    const [isDpt, setIsDpt] = useState(false);
    const getPartyDetails = async () => {
        try {
            const partyCode = localStorage.getItem("user-party-code");
            const personType = localStorage.getItem("party-person-type");
            setPartyPersonType(personType);
            if (!partyCode) {
                throw new Error("No partyCode in localStorage");
            }
            const res = personType == "INDIVIDUAL" ?
                await api.party.getIndividualDetails(partyCode)
                : await api.party.getOrganisationDetails(partyCode);
            setPartyDetails(res);
            const mappedData = {
                name: personType == "INDIVIDUAL" ? null : res?.data?.name,
                firstName: personType == "INDIVIDUAL" ? res?.data?.firstName : null,
                lastName: personType == "INDIVIDUAL" ? res?.data?.lastName : null,
                email: res.mails?.values?.[0]?.value ?? null,
                phone: res.phones?.values?.[0]?.number ?? null,
                phoneType: res.phones?.values?.[0]?.type?.code ?? null,
                locationCode: res.phones?.values?.[0]?.locationCode ?? null,
                areaCode: res.phones?.values?.[0]?.areaCode ?? null,
                addressType: res.addresses?.values?.[0]?.type?.code ?? null,
                street: res.addresses?.values?.[0]?.street ?? null,
                number: res.addresses?.values?.[0]?.number ?? null,
                floor: res.addresses?.values?.[0]?.floor ?? null,
                apartment: res.addresses?.values?.[0]?.apartment ?? null,
                city: res.addresses?.values?.[0]?.city?.code ?? null,
                province: res.addresses?.values?.[0]?.city?.province?.code ?? null,
                zipCode: res.addresses?.values?.[0]?.postalCode?.number ?? null,
                country: res.addresses?.values?.[0]?.city?.province?.country?.code ?? null,
                birthDate: res.data.birthdate ?? null,
                documentType: res.identifications?.values?.find((i) => i.default)?.type?.code ?? null,
                documentNumber: res.identifications?.values?.find((i) => i.default)?.value ?? null,
            };
            setIsDpt(res.addresses?.values?.[0]?.floor || res.addresses?.values?.[0]?.apartment
                ? true
                : false);
            if (mappedData?.province != null) {
                fetchCities(mappedData?.province);
            }
            if (mappedData?.city != null) {
                fetchPostalCodes(mappedData?.city);
            }
            setPersonalData(mappedData);
            personalForm.setFieldsValue(mappedData);
        }
        catch (error) {
            openNotificationWithIcon(TYPE.ERROR, error?.response?.data?.message || error?.message || "error looking for party data");
        }
    };
    const isPhoneRequired = () => {
        return personalFormValues?.phoneType || personalFormValues?.locationCode || personalFormValues?.phoneType || personalFormValues?.phone;
    };
    const isAddressRequired = () => {
        return personalFormValues?.addressType || personalFormValues?.street || personalFormValues?.number || personalFormValues?.province || personalFormValues?.city || personalFormValues?.zipCode;
    };
    const handlePersonalDataSubmit = async (values) => {
        try {
            setLoading(true);
            console.log("Values", values);
            console.log("partyDetails", partyDetails);
            const commonData = {
                identifications: {
                    values: partyDetails?.identifications?.values?.map((identification, index) => ({
                        value: index === 0 ? values.documentNumber : identification.value,
                        typeCode: index === 0 ? values.documentType : identification.type.code,
                    })),
                },
                mails: {
                    values: partyDetails?.mails?.values?.map((mail, index) => ({
                        value: index === 0 ? values.email : mail.value,
                        typeCode: mail.type.code,
                    })),
                },
                phones: partyDetails?.phones?.values?.length > 0 || isPhoneRequired() ? {
                    values: partyDetails?.phones?.values?.length > 0 ? partyDetails?.phones?.values?.map((phone, index) => ({
                        locationCode: index === 0 ? values.locationCode : phone.locationCode,
                        areaCode: index === 0 ? values.areaCode : phone.areaCode,
                        number: index === 0 ? values.phone : phone.number,
                        typeCode: index === 0 ? values.phoneType : phone.type.code,
                        extension: phone.extension,
                    })) : [{
                            locationCode: values.locationCode,
                            areaCode: values.areaCode,
                            number: values.phone,
                            typeCode: values.phoneType,
                            extension: null,
                        }],
                } : null,
                addresses: partyDetails?.addresses?.values?.length > 0 ? {
                    values: partyDetails?.addresses?.values?.map((address, index) => ({
                        street: index === 0 ? values.street : address.street,
                        number: index === 0 ? Number(values.number) : address.number,
                        floor: index === 0 ? values.floor ?? null : address.floor,
                        apartment: index === 0 ? values.apartment?.toUpperCase() ?? null : address.apartment,
                        observations: address.observations,
                        cityCode: index === 0 ? values.city : address.city.code,
                        postalCode: index === 0 ? values.zipCode : address.postalCode.number,
                        typeCode: address.type.code,
                        latitude: address.latitude,
                        longitude: address.longitude,
                    })),
                } : isAddressRequired() ? {
                    values: [{
                            street: values.street,
                            number: Number(values.number),
                            floor: values.floor,
                            apartment: values.apartment?.toUpperCase(),
                            observations: null,
                            cityCode: values.city,
                            postalCode: values.zipCode,
                            typeCode: values.addressType,
                            latitude: null,
                            longitude: null,
                        }]
                } : null,
                practices: {
                    values: partyDetails?.practices?.values?.map((practice) => ({
                        isicCode: practice.isicCode,
                    })),
                },
                fiscalCategories: partyDetails?.fiscalCategories?.values?.length > 0 ? {
                    values: partyDetails?.fiscalCategories?.values?.map((category) => ({
                        typeCode: category.fiscalCategory.code,
                    })),
                } : null,
            };
            const data = partyPersonType === "INDIVIDUAL"
                ? {
                    data: {
                        firstName: values.firstName,
                        lastName: values.lastName,
                        birthdate: partyDetails?.data?.birthdate,
                        maritalStatusCode: partyDetails?.data?.maritalStatus?.code,
                    },
                    nationalities: {
                        values: partyDetails?.nationalities?.values?.map((n) => ({
                            code: n.code,
                        })),
                    },
                    workerTypes: partyDetails?.workerTypes?.values?.length > 0 ? {
                        values: partyDetails?.workerTypes?.values?.map((w) => ({
                            code: w.code,
                        })),
                    } : null,
                    economicClasses: partyDetails?.economicClasses?.values?.length > 0 ? {
                        values: partyDetails?.economicClasses?.values?.map((economic) => ({
                            code: economic.code,
                            name: economic.name,
                        })),
                    } : null,
                    ...commonData,
                }
                : {
                    data: {
                        name: values.name,
                        foundationDate: partyDetails?.data?.foundationDate,
                        typeCode: partyDetails?.data?.typeCode?.code || null,
                    },
                    ...commonData
                };
            const partyCode = localStorage.getItem("user-party-code");
            if (!partyCode) {
                throw new Error("Not party code found, invalid user");
            }
            const res = partyPersonType === "INDIVIDUAL" ?
                await api.party.updatePerson(partyCode, data) :
                await api.party.updateOrganization(partyCode, data);
            openNotificationWithIcon(TYPE.SUCCESS, `Los datos han sido actualizados de forma exitosa.`);
        }
        catch (error) {
            openNotificationWithIcon(TYPE.ERROR, error?.response?.data?.message ??
                error?.message ??
                "Error actualizando los datos");
        }
        finally {
            setLoading(false);
        }
    };
    const fetchCardTypes = async () => {
        const res = await api.finance.getCardTypes();
        const types = res?.values.map((t) => ({
            value: t?.code,
            label: t?.name,
        }));
        setCardTypes(types);
    };
    const fetchIdentificationTypes = async () => {
        const personType = localStorage.getItem("party-person-type");
        setPartyPersonType(personType);
        const res = await api.party.getIdentificationTypes(partyPersonType || "INDIVIDUAL", "ARG");
        const identificationTypes = res?.values.map((i) => ({
            value: i?.code,
            label: i?.name,
        }));
        setDocumentTypeOptions(identificationTypes);
    };
    const fetchBanks = async () => {
        const res = await api.finance.getBanks();
        const banks = res?.values.map((b) => ({
            value: b?.code,
            label: b?.name,
        }));
        setBanks(banks);
    };
    const fetchProvinces = async () => {
        const res = await api.location.getProvinces("ARG");
        const provincesOptions = res?.provinces?.map((b) => ({
            value: b?.code,
            label: b?.name,
        }));
        setProvinces(provincesOptions);
    };
    const fetchCities = async (provinceSelected) => {
        const res = await api.location.getCities(provinceSelected);
        const citiesOptions = res?.cities?.map((b) => ({
            value: b?.code,
            label: b?.name,
        }));
        setCities(citiesOptions);
    };
    const fetchPostalCodes = async (citySelected) => {
        const res = await api.location.getPostalCodes(citySelected);
        const postalCodesOptions = res?.values?.map((b) => ({
            value: b?.number,
            label: b?.number,
        }));
        setPostalCodes(postalCodesOptions);
    };
    const fetchPaymentMethods = async () => {
        try {
            const partyCode = localStorage.getItem("user-party-code");
            if (!partyCode) {
                throw new Error("No partyCode in localStorage");
            }
            const res = await api.party.getPaymentMethodsByPartyCode(partyCode);
            setPaymentMethodsFromEP(res);
            const mapped = mapPaymentMethods(res);
            setPaymentMethods(mapped);
            console.log("payment methods", res);
        }
        catch (error) {
            openNotificationWithIcon(TYPE.ERROR, error ?? "error looking for party paymentMethods");
        }
    };
    useEffect(() => {
        fetchIdentificationTypes();
        fetchBanks();
        fetchCardTypes();
        getPartyDetails();
        fetchProvinces();
        fetchPaymentMethods();
    }, []);
    const [paymentMethodsFromEP, setPaymentMethodsFromEP] = useState();
    const [canUpdateData, setCanUpdateData] = useState(true);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const maskCardNumber = (num) => `**** **** **** ${num.slice(-4)}`;
    const formatExpiry = (date) => {
        // "2032-12-17" -> "12/32"
        const [year, month] = date.split('-');
        return `${month}/${year.slice(-2)}`;
    };
    const mapPaymentMethods = (data) => {
        const result = [];
        // 💳 Credit Cards
        data.creditCardData?.values?.forEach((card) => {
            result.push({
                id: card.code,
                type: 'credit',
                cardNumber: maskCardNumber(card.number),
                cardHolder: card.ownerName,
                expiryDate: formatExpiry(card.dateTo),
                bank: card.cardProvider?.name,
                isDefault: false, // ⚠️ no viene del backend
                lastUsed: undefined,
            });
        });
        // 🏦 Bank Accounts
        data.bankAccountData?.values?.forEach((account) => {
            result.push({
                id: account.code,
                type: 'bank',
                cardNumber: `******************${account.cbu.slice(-4)}`,
                cardHolder: account.bankAccountType.name,
                expiryDate: '-', // no aplica
                bank: account.bankBranch?.bank?.name,
                isDefault: false,
                lastUsed: undefined,
            });
        });
        // 💵 Cash (opcional)
        data.cashData?.values?.forEach((cash, index) => {
            result.push({
                id: `cash-${index}`,
                type: 'cash',
                cardNumber: cash.currencyName,
                currencyCode: cash.currencyCode,
                cardHolder: '-',
                expiryDate: '-',
                bank: '-',
                isDefault: false,
                lastUsed: undefined,
            });
        });
        return result;
    };
    const formatData = (updatedPayments) => {
        return {
            cashData: updatedPayments?.cashData?.values?.length > 0
                ? {
                    values: updatedPayments.cashData.values.map((el) => {
                        return {
                            currencyCode: el?.currencyCode,
                        };
                    }),
                }
                : null,
            creditCardData: updatedPayments?.creditCardData?.values?.length > 0
                ? {
                    values: updatedPayments.creditCardData.values.map((el) => {
                        return {
                            ownerName: el?.ownerName,
                            number: el?.number,
                            securityCode: el?.securityCode,
                            dateFrom: el?.dateFrom || null,
                            dateTo: el?.dateTo,
                            typeCode: el?.cardType?.code ||
                                el?.typeCode ||
                                el?.code,
                            providerCode: el?.cardProvider?.code ||
                                el?.providerCode,
                        };
                    }),
                }
                : null,
            bankAccountData: updatedPayments?.bankAccountData?.values?.length > 0
                ? {
                    values: updatedPayments.bankAccountData.values.map((el) => {
                        return {
                            number: el?.number,
                            cbu: el?.cbu,
                            alias: el?.alias || "",
                            currencyCode: el?.currency?.code || el?.currencyCode,
                            bankBranchCode: el?.bankBranch?.code ||
                                el?.bankBranchCode,
                            bankAccountTypeCode: el?.bankAccountType?.code ||
                                el?.bankAccountTypeCode,
                        };
                    }),
                }
                : null,
        };
    };
    const onAddPaymentMethod = async (newPaymentMethod) => {
        const partyCode = localStorage.getItem("user-party-code");
        if (!partyCode) {
            throw new Error("No partyCode in localStorage");
        }
        const typeKey = newPaymentMethod.type === "cashMethodData" ? "cashData" : newPaymentMethod.type;
        // Agregar nuevo payment si ya hay anteriores (ademas ahora acepta mas de un metodo por tipo) @Fran
        const updatedPayments = formatData({
            ...paymentMethodsFromEP,
            [typeKey]: {
                ...(paymentMethodsFromEP?.[typeKey] ?? {}),
                values: [
                    ...(paymentMethodsFromEP?.[typeKey]?.values ?? []),
                    newPaymentMethod,
                ],
            },
        });
        try {
            await api.party.updatePaymentMethodsByPartyCode(partyCode, updatedPayments);
            openNotificationWithIcon(TYPE.SUCCESS, "Metodo de pago actualizado exitosamente");
            fetchPaymentMethods();
            setPaymentModalVisible(false);
        }
        catch (error) {
            console.error("Error al agregar el método de pago:", error);
        }
    };
    const handleDeletePaymentMethod = async (record) => {
        try {
            const partyCode = localStorage.getItem("user-party-code");
            if (!partyCode) {
                throw new Error("No partyCode in localStorage");
            }
            const { bankAccountData, creditCardData, cashData } = paymentMethodsFromEP;
            const post_data = {
                bankAccountData: record.type === "bank"
                    ? {
                        values: bankAccountData.values
                            .filter((el) => el.code !== record.id)
                            .map((el) => ({
                            number: el.number,
                            cbu: el.cbu,
                            currencyCode: el.currency.code,
                            bankBranchCode: el.bankBranch.code,
                            bankAccountTypeCode: el.bankAccountType.code,
                        })),
                    }
                    : bankAccountData.values.length > 0
                        ? {
                            values: bankAccountData.values.map((el) => ({
                                number: el.number,
                                cbu: el.cbu,
                                currencyCode: el.currency.code,
                                bankBranchCode: el.bankBranch.code,
                                bankAccountTypeCode: el.bankAccountType.code,
                            })),
                        }
                        : null,
                creditCardData: record.type === "credit"
                    ? {
                        values: creditCardData.values
                            .filter((el) => el.code !== record.id)
                            .map((el) => ({
                            ownerName: el.ownerName,
                            number: el.number,
                            securityCode: el.securityCode,
                            dateFrom: el.dateFrom,
                            dateTo: el.dateTo,
                            typeCode: el.cardType.code || el.typeCode,
                            providerCode: el.cardProvider?.code || el.providerCode,
                        })),
                    }
                    : creditCardData.values.length > 0
                        ? {
                            values: creditCardData.values.map((el) => ({
                                ownerName: el.ownerName,
                                number: el.number,
                                securityCode: el.securityCode,
                                dateFrom: el.dateFrom,
                                dateTo: el.dateTo,
                                typeCode: el.cardType.code || el.typeCode,
                                providerCode: el.cardProvider?.code || el.providerCode,
                            })),
                        }
                        : null,
                cashData: record.type === "cash"
                    ? {
                        values: cashData.values.filter((el) => el.currencyCode !== record.currencyCode),
                    }
                    : cashData.values.length > 0
                        ? {
                            values: cashData.values.map((el) => ({
                                currencyCode: el.currencyCode,
                            })),
                        }
                        : null,
            };
            await api.party.updatePaymentMethodsByPartyCode(partyCode, post_data);
            fetchPaymentMethods();
            openNotificationWithIcon(TYPE.SUCCESS, "Método de pago eliminado correctamente");
        }
        catch (error) {
            message.error("Error al eliminar el método de pago");
        }
    };
    const handleSetDefaultPayment = async (id) => {
        try {
            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 500));
            setPaymentMethods(prev => prev.map(pm => ({ ...pm, isDefault: pm.id === id })));
            message.success('Método de pago predeterminado actualizado');
        }
        catch (error) {
            message.error('Error al actualizar el método de pago predeterminado');
        }
    };
    const paymentColumns = [
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            render: (type) => (_jsx(Tag, { color: type === 'credit' ? 'blue' : type === "cash" ? "orange" : 'green', children: type === 'credit' ? 'Crédito' : type === "cash" ? "Efectivo" : 'Débito' })),
        },
        {
            title: 'Tarjeta',
            dataIndex: 'cardNumber',
            key: 'cardNumber',
            render: (cardNumber, record) => (_jsxs(Space, { direction: "vertical", size: 0, children: [_jsx(Text, { strong: true, children: cardNumber }), _jsx(Text, { type: "secondary", style: { fontSize: '12px' }, children: record.cardHolder })] })),
        },
        {
            title: 'Banco',
            dataIndex: 'bank',
            key: 'bank',
        },
        {
            title: 'Vencimiento',
            dataIndex: 'expiryDate',
            key: 'expiryDate',
        },
        {
            title: 'Acciones',
            key: 'actions',
            render: (_, record) => (_jsxs(Space, { children: [_jsx(Button, { type: "text", icon: _jsx(EditOutlined, {}), onClick: () => {
                            setEditingPayment(record);
                            paymentForm.setFieldsValue({
                                type: record.type,
                                cardHolder: record.cardHolder,
                                expiryDate: record.expiryDate,
                                bank: record.bank,
                                isDefault: record.isDefault,
                            });
                            setPaymentModalVisible(true);
                        } }), !record.isDefault && (_jsx(Button, { type: "text", icon: _jsx(SafetyOutlined, {}), onClick: () => handleSetDefaultPayment(record.id), title: "Establecer como predeterminada" })), _jsx(Popconfirm, { title: "\u00BFEst\u00E1 seguro de eliminar este m\u00E9todo de pago?", onConfirm: () => handleDeletePaymentMethod(record), okText: "S\u00ED", cancelText: "No", children: _jsx(Button, { type: "text", danger: true, icon: _jsx(DeleteOutlined, {}), disabled: record.isDefault }) })] })),
        },
    ];
    const personalDataTab = (_jsxs(Card, { children: [_jsxs(Title, { level: 4, children: [_jsx(UserOutlined, {}), " Datos Personales"] }), _jsxs(Form, { form: personalForm, layout: "vertical", initialValues: personalData, onFinish: handlePersonalDataSubmit, onValuesChange: (changedValues) => {
                    if (changedValues.province) {
                        fetchCities(changedValues.province);
                        personalForm.setFieldsValue({ city: undefined, zipCode: undefined }); // reset ciudad y zipCode
                    }
                    if (changedValues.city) {
                        fetchPostalCodes(changedValues.city);
                        personalForm.setFieldsValue({ zipCode: undefined }); // reset zipCode
                    }
                }, children: [partyPersonType === "INDIVIDUAL" ?
                        _jsxs(Row, { gutter: 16, children: [_jsx(Col, { xs: 24, sm: 12, children: _jsx(Form.Item, { label: "Nombre", name: "firstName", rules: [{ required: true, message: 'El nombre es requerido' }], children: _jsx(Input, { prefix: _jsx(UserOutlined, {}), placeholder: "Ingrese su nombre", disabled: !canUpdateData }) }) }), _jsx(Col, { xs: 24, sm: 12, children: _jsx(Form.Item, { label: "Apellido", name: "lastName", rules: [{ required: true, message: 'El apellido es requerido' }], children: _jsx(Input, { prefix: _jsx(UserOutlined, {}), placeholder: "Ingrese su apellido", disabled: !canUpdateData }) }) })] }) :
                        _jsx(Row, { gutter: 16, children: _jsx(Col, { xs: 24, sm: 12, children: _jsx(Form.Item, { label: "Razon social", name: "name", rules: [{ required: true, message: 'La razon social es requerida' }], children: _jsx(Input, { prefix: _jsx(IoBusinessOutline, {}), placeholder: "Ingrese su nombre", disabled: !canUpdateData }) }) }) }), _jsxs(Row, { gutter: 16, children: [_jsx(Col, { xs: 24, sm: 12, children: _jsx(Form.Item, { label: "Tipo de identificacion", name: "documentType", rules: [{ required: true, message: 'Seleccione el tipo de documento' }], children: _jsx(Select, { placeholder: "Seleccione tipo de identificacion", disabled: true, children: documentTypeOptions.map((option) => (_jsx(Option, { value: option.value, children: option.label }, option.value))) }) }) }), _jsx(Col, { xs: 24, sm: 12, children: _jsx(Form.Item, { label: "N\u00FAmero de identificacion", name: "documentNumber", rules: [{ required: true, message: 'El número de documento es requerido' }], children: _jsx(Input, { placeholder: "Ingrese n\u00FAmero de documento", disabled: true }) }) })] }), _jsx(Divider, { orientation: "left", children: "Informaci\u00F3n de Contacto" }), _jsx(Row, { gutter: 16, children: _jsx(Col, { xs: 24, sm: 12, children: _jsx(Form.Item, { label: "Email", name: "email", rules: [
                                    { required: true, message: 'El email es requerido' },
                                    { type: 'email', message: 'Ingrese un email válido' }
                                ], children: _jsx(Input, { prefix: _jsx(MailOutlined, {}), placeholder: "Ingrese su email", disabled: !canUpdateData }) }) }) }), _jsxs(Row, { gutter: 16, children: [_jsx(Col, { xs: 24, sm: 6, children: _jsx(Form.Item, { label: "Tipo de telefono", name: "phoneType", rules: [
                                        {
                                            required: isPhoneRequired(),
                                            message: "Este campo es requerido",
                                        },
                                    ], children: _jsx(Select, { allowClear: true, placeholder: "Tipo de telefono", children: phoneTypes.map((type) => (_jsx(Option, { value: type.code, children: type.name }, type.code))) }) }) }), _jsx(Col, { xs: 24, sm: 6, children: _jsx(Form.Item, { label: "Codigo pais", name: "locationCode", rules: [
                                        {
                                            required: isPhoneRequired(),
                                            message: "Este campo es requerido",
                                        },
                                        {
                                            max: 3,
                                            message: "Maximo 3 caracteres",
                                        },
                                    ], children: _jsx(Input, { type: "number", addonBefore: "+", placeholder: "Codigo de pais" }) }) }), _jsx(Col, { xs: 24, sm: 6, children: _jsx(Form.Item, { label: "Codigo de area", name: "areaCode", rules: [
                                        {
                                            required: isPhoneRequired(),
                                            message: "Este campo es requerido",
                                        },
                                        {
                                            max: 3,
                                            message: "Maximo 3 caracteres",
                                        },
                                    ], children: _jsx(Input, { type: "number", addonBefore: "+", placeholder: "Codigo de area" }) }) }), _jsx(Col, { xs: 24, sm: 6, children: _jsx(Form.Item, { label: "Telefono", name: "phone", rules: [
                                        {
                                            required: isPhoneRequired(),
                                            message: "Este campo es requerido",
                                        },
                                        {
                                            min: 4,
                                            message: "Minimo 4 caracteres"
                                        }
                                    ], children: _jsx(Input, { prefix: _jsx(PhoneOutlined, {}), placeholder: "Numero", disabled: !canUpdateData }) }) })] }), _jsx(Divider, { orientation: "left", children: "Direcci\u00F3n" }), _jsx(Row, { children: _jsx(Col, { xs: 24, sm: 8, children: _jsx(Form.Item, { label: "Tipo de domicilio", name: "addressType", rules: [
                                    {
                                        required: isAddressRequired(),
                                        message: "Este campo es requerido",
                                    },
                                ], children: _jsx(Select, { allowClear: true, placeholder: "Tipo de domicilio", children: addressesTypes.map((type) => (_jsx(Option, { value: type.code, children: type.name }, type.code))) }) }) }) }), _jsxs(Row, { gutter: 16, children: [_jsx(Col, { xs: 24, sm: 8, children: _jsx(Form.Item, { label: "Calle", name: "street", rules: [{ required: isAddressRequired(), message: 'La dirección es requerida' }], children: _jsx(Input, { prefix: _jsx(HomeOutlined, {}), placeholder: "Ingrese su direcci\u00F3n completa", disabled: !canUpdateData }) }) }), _jsx(Col, { xs: 24, sm: 6, children: _jsx(Form.Item, { label: "Numero", name: "number", rules: [{ required: isAddressRequired(), message: 'La dirección es requerida' }], children: _jsx(Input, { placeholder: "Ingrese su direcci\u00F3n completa", disabled: !canUpdateData }) }) }), _jsx(Col, { style: { justifyContent: "center", alignItems: "center" }, children: _jsx(Form.Item, { name: "isDpt", label: " ", style: { display: "flex", justifyContent: "center" }, children: _jsx(Checkbox, { checked: isDpt, onChange: (e) => setIsDpt(e.target.checked), children: "Depto" }) }) }), _jsx(Col, { xs: 24, sm: 6, children: isDpt && (_jsxs(Row, { style: { width: "100%" }, gutter: 16, children: [_jsx(Col, { xs: 12, sm: 12, children: _jsx(Form.Item, { label: "Piso", name: "floor", rules: [
                                                    {
                                                        max: 10,
                                                        message: "Maximo 10 caracteres"
                                                    },
                                                    {
                                                        pattern: /^\d+$/,
                                                        message: "Debe ser numerico",
                                                    },
                                                ], children: _jsx(Input, { type: 'number', placeholder: "numero de piso", disabled: !canUpdateData }) }) }), _jsx(Col, { xs: 12, sm: 12, children: _jsx(Form.Item, { label: "Departamento", name: "apartment", rules: [
                                                    {
                                                        max: 5,
                                                        message: "Maximo 5 caracteres"
                                                    },
                                                ], children: _jsx(Input, { placeholder: "Departamento", disabled: !canUpdateData }) }) })] })) })] }), _jsxs(Row, { gutter: 16, children: [_jsx(Col, { xs: 24, sm: 8, children: _jsx(Form.Item, { label: "Provincia", name: "province", rules: [{ required: isAddressRequired(), message: 'La provincia es requerida' }], children: _jsx(Select, { placeholder: "Seleccione provincia", disabled: !canUpdateData, children: provinces?.map((option) => (_jsx(Option, { value: option.value, children: option.label }, option.value))) }) }) }), _jsx(Col, { xs: 24, sm: 8, children: _jsx(Form.Item, { label: "Ciudad", name: "city", rules: [{ required: isAddressRequired(), message: 'La ciudad es requerida' }], children: _jsx(Select, { placeholder: "Seleccione ciudad", disabled: !personalForm.getFieldValue("province") || !canUpdateData, children: cities?.map((option) => (_jsx(Option, { value: option.value, children: option.label }, option.value))) }) }) }), _jsx(Col, { xs: 24, sm: 8, children: _jsx(Form.Item, { label: "C\u00F3digo Postal", name: "zipCode", rules: [{ required: isAddressRequired(), message: 'El código postal es requerido' }], children: _jsx(Select, { placeholder: "C\u00F3digo Postal", disabled: !personalForm.getFieldValue("city") || !canUpdateData, children: postalCodes?.map((option) => (_jsx(Option, { value: option.value, children: option.label }, option.value))) }) }) })] }), _jsx(Form.Item, { children: _jsx(Button, { type: "primary", htmlType: "submit", loading: loading, size: "large", disabled: !canUpdateData, children: "Actualizar Datos Personales" }) })] })] }));
    const paymentMethodsTab = (_jsxs(Card, { children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }, children: [_jsxs(Title, { level: 4, children: [_jsx(CreditCardOutlined, {}), " M\u00E9todos de Pago"] }), _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => {
                            setEditingPayment(null);
                            paymentForm.resetFields();
                            setPaymentModalVisible(true);
                        }, children: "Agregar Medio de pago" })] }), _jsx(Table, { columns: paymentColumns, dataSource: paymentMethods, rowKey: "id", pagination: false, size: "middle" }), _jsx(Modal, { title: editingPayment ? 'Editar Método de Pago' : 'Agregar Método de Pago', open: paymentModalVisible, onCancel: () => {
                    setPaymentModalVisible(false);
                    setEditingPayment(null);
                }, footer: null, width: 600, children: _jsx(PaymentMethods, { onAddPaymentMethod: onAddPaymentMethod, dataFormattedForEndpoint: true, onCancel: () => {
                        setPaymentModalVisible(false);
                        setEditingPayment(null);
                    }, withConfirmation: true }) })] }));
    const tabItems = [
        {
            key: 'personal',
            label: 'Datos Personales',
            children: personalDataTab,
            icon: _jsx(UserOutlined, {}),
        },
        {
            key: 'payment',
            label: 'Métodos de Pago',
            children: paymentMethodsTab,
            icon: _jsx(CreditCardOutlined, {}),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Title, { level: 2, children: [_jsx(UserOutlined, {}), " Mi Perfil"] }), _jsx(Text, { type: "secondary", style: { fontSize: '16px', marginBottom: '24px', display: 'block' }, children: "Gestione sus datos personales y configure sus m\u00E9todos de pago preferidos" }), _jsx(Tabs, { defaultActiveKey: "personal", items: tabItems, size: "large", style: { marginTop: 24 } })] }));
};
export default ProfilePage;
